var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 3.75C14.3646 3.89583 14.375 4.03125 14.375 4.15625C14.375 5.63542 14.0104 7.08333 13.2812 8.5C12.5729 9.91667 11.5208 11.0938 10.125 12.0312C8.75 12.9688 7.05208 13.4583 5.03125 13.5C3.15625 13.4792 1.47917 12.9896 0 12.0312C0.25 12.0521 0.510417 12.0625 0.78125 12.0625C2.34375 12.0417 3.70833 11.5729 4.875 10.6562C4.125 10.6354 3.47917 10.4167 2.9375 10C2.39583 9.58333 2.02083 9.05208 1.8125 8.40625C2 8.42708 2.19792 8.4375 2.40625 8.4375C2.71875 8.4375 3.01042 8.40625 3.28125 8.34375C2.51042 8.17708 1.88542 7.80208 1.40625 7.21875C0.927083 6.63542 0.677083 5.9375 0.65625 5.125V5.0625C1.09375 5.3125 1.58333 5.45833 2.125 5.5C1.20833 4.85417 0.71875 3.9375 0.65625 2.75C0.677083 2.14583 0.833333 1.59375 1.125 1.09375C1.9375 2.09375 2.92708 2.89583 4.09375 3.5C5.23958 4.10417 6.5 4.44792 7.875 4.53125C7.83333 4.28125 7.8125 4.03125 7.8125 3.78125C7.83333 2.86458 8.14583 2.09375 8.75 1.46875C9.375 0.84375 10.1458 0.520833 11.0625 0.5C12.0417 0.520833 12.8438 0.864583 13.4688 1.53125C14.2188 1.38542 14.9167 1.125 15.5625 0.75C15.2917 1.52083 14.8125 2.125 14.125 2.5625C14.7708 2.47917 15.3958 2.30208 16 2.03125C15.5417 2.69792 14.9896 3.27083 14.3438 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7255bb087e4c5dc4ed2ce2e6d6cbc336.svg";
export { ForwardRef as ReactComponent };